import {Column, Text, useDisclose} from 'native-base';
import {CreateTeamButtonSmall} from './CreateTeamButton';
import {IHStackProps} from 'native-base/lib/typescript/components/primitives/Stack/HStack';
import {IVStackProps} from 'native-base/lib/typescript/components/primitives/Stack/VStack';
import React from 'react';
import {TeamCreateModal} from '@ui/features/auth/team/TeamCreateModal';
import TeamItem from './TeamItem';
import {TeamUiData} from '@shared/models/team';
import {useTranslation} from 'react-i18next';

interface Props {
    teams: TeamUiData[];
    onPress: (teamId: string) => void;
    teamIdLoading?: string;
    _column?: IVStackProps;
    showCreateButton?: boolean;
    _item?: IHStackProps;
}

const UserTeams = (props: Props) => {
    const {onPress, teamIdLoading, _column, teams, _item, showCreateButton = false} = props;
    const {isOpen, onOpen, onClose} = useDisclose();

    const hasTeams = !!teams.length;

    if (!teams.length) {
        return (
            <>
                <NoTeams {...props} />

                {showCreateButton && <CreateTeamButtonSmall onPress={onOpen}/>}

                <TeamCreateModal onTeamCreated={onPress} isOpen={isOpen} onClose={onClose}/>
            </>
        );
    }

    return (
        <>
            <Column space={2} {..._column}>
                {hasTeams ?
                    teams.map((team) => (
                        <TeamItem
                            key={team.id}
                            team={team}
                            onPress={() => onPress(team.id)}
                            isLoading={teamIdLoading === team.id}
                            _row={_item}
                        />
                    ))
                    : <NoTeams {...props}/>}

                {showCreateButton && <CreateTeamButtonSmall onPress={onOpen}/>}
            </Column>

            <TeamCreateModal onTeamCreated={onPress} isOpen={isOpen} onClose={onClose}/>
        </>
    );
};

export default UserTeams;

const NoTeams = (props: Props) => {
    const {_column} = props;
    const {t} = useTranslation();

    return (
        <Column
            space={6}
            py={4}
            {..._column}
            justifyContent='center'
        >
            <Text color='light.600' textAlign="center">{t('auth.teams.notMemberOfTeam')}</Text>
        </Column>
    );
};

